import { GameLang } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/lang/GameLang";
import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { AbstractControlPanelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractControlPanelProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "@lib/titan2/dist/game/control/properties/ToggleButtonProperties";
import { Circle, Point } from "pixi.js";
import { OptionsLandscapeProperties } from "../landscape/ControlPanelLandscapeProperties";
/**
 * ControlPanelPortraitProperties.ts
 */
export class ControlPanelPortraitProperties extends AbstractControlPanelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.logoProperties.position.set(228, 49);
        this.spinButtonPosition = new Point(378, 1590);
        this.spinButtonProperties.hitArea = new Circle(150, 145, 130);
        this.spinButtonProperties.trackingId = GameStyle.SPIN_BUTTON;
        this.purchaseSpinButtonProperties.textFieldOffset = new Point(0, -60);
        this.purchaseSpinButtonProperties.textFieldProperties.position = new Point(136, 123);
        this.purchaseSpinButtonProperties.textFieldProperties.setVerticalAlign(ControlConstants.BOTTOM);
        this.purchaseSpinButtonProperties.textFieldProperties.size = new Point(150, 160);
        this.purchaseSpinButtonProperties.textFieldProperties.multiline = true;
        this.purchaseSpinButtonProperties.hitArea = new Circle(150, 145, 130);
        this.purchaseSpinButtonProperties.disableTextAlpha = 0.6;
        this.startGameButtonProperties.hitArea = new Circle(150, 145, 130);
        this.payTableButtonProperties.position.set(856, 168);
        this.payTableButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.PAY_TABLE_BUTTON, undefined, GameLang.OPTIONS_PAYS, ControlConstants.CENTER, ControlConstants.CENTER, new Point(120, 70));
        this.freeSpinButtonProperties.hitArea = new Circle(150, 145, 130);
        this.freeSpinButtonProperties.textFieldProperties = undefined;
        this.freeSpinButtonProperties.disableAlign = true;
        this.spinPriceProperties.position = new Point(136, 120);
        this.spinPriceProperties.size = new Point(200, 150);
        this.collectButtonProperties = new ToggleButtonProperties(SlingoStyle.COLLECT_BUTTON, GameStyle.MODULE, new Point(36, 1339));
        this.collectButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.COLLECT_BUTTON, new Point(288, 26), GameLang.COLLECT_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.collectButtonProperties.disableAlign = true;
        this.collectButtonValueTextFieldProperties = new TextFieldProperties(GameFontStyle.COLLECT_BUTTON_VALUE_TEXT, new Point(670, 24), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.collectButtonProperties.scale.set(1.003);
        this.endGameButtonProperties = new ToggleButtonProperties(SlingoStyle.END_GAME_BUTTON, GameStyle.MODULE, new Point(36, 1339));
        this.endGameButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.END_GAME_BUTTON, new Point(288, 23), GameLang.END_GAME_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER, new Point(340, 160));
        this.endGameButtonProperties.textFieldOffset = new Point(0, -12);
        this.endGameButtonProperties.scale.set(1.003);
    }
}
/**
 * OptionsPortraitProperties.ts
 */
export class OptionsPortraitProperties extends OptionsLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundAlpha = 0.6;
        this.optionsButtonProperties.position.set(837, 1568);
        this.optionsButtonProperties.scale.set(1);
        this.panelProperties.position.set(132, 560);
        this.panelProperties.scale.set(1);
        let size = new Point(500, 100);
        let textFieldOffset = new Point(-235, 0);
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.payTableButtonProperties.textFieldProperties.size = size;
        this.payTableButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.payTableButtonProperties.textFieldOffset = textFieldOffset;
        this.SFXButtonProperties.textFieldProperties.size = size;
        this.SFXButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.SFXButtonProperties.textFieldOffset = textFieldOffset;
        this.helpButtonProperties.textFieldProperties.size = size;
        this.helpButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.helpButtonProperties.textFieldOffset = textFieldOffset;
        this.homeButtonProperties.textFieldProperties.size = size;
        this.homeButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.homeButtonProperties.textFieldOffset = textFieldOffset;
        this.depositButtonProperties.textFieldProperties.size = size;
        this.depositButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.depositButtonProperties.textFieldOffset = textFieldOffset;
        this.dghButtonProperties.textFieldProperties.size = size;
        this.dghButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.dghButtonProperties.textFieldOffset = textFieldOffset;
        this.responsibleGamingButtonProperties.textFieldProperties.size = size;
        this.responsibleGamingButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.responsibleGamingButtonProperties.textFieldOffset = textFieldOffset;
        this.hasPayTable = false;
    }
}
//# sourceMappingURL=ControlPanelPortraitProperties.js.map